export default {
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.settings': '设置',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.open-platform': '开放平台',
  'menu.open-platform.internal-applications': '应用对接',
  'menu.open-platform.self-built-applications': '企业对接',
  'menu.open-platform.personal-applications': '个人对接',
  'menu.open-platform.saas-group': '平台对接',
  'menu.open-platform.saas-applications': '平台对接',
  'menu.open-platform.authorized-saas-applications': '已授权平台对接',
  'menu.open-platform.saas-group.open-platform.saas-applications': '平台对接',
  'menu.open-platform.saas-group.open-platform.authorized-saas-applications':
    '已授权平台对接',
  'menu.open-platform.saas-group.saas-applications': '平台对接',
  'menu.open-platform.saas-group.authorized-saas-applications':
    '已授权平台对接',
  'menu.open-platform.saas-docs': '对接文档',
  'menu.open-platform.saas-group.open-platform.saas-docs': '对接文档',
  'menu.open-platform.saas-group.saas-docs': '对接文档',
  'menu.open-platform.saas-user-authorizations': '平台用户授权',
  'menu.open-platform.saas-group.open-platform.saas-user-authorizations':
    '平台用户授权',
  'menu.open-platform.saas-group.saas-user-authorizations': '平台用户授权',
  'menu.open-platform.services': '开放能力',
  'menu.open-platform.skills': 'Skill 市场',
  'menu.open-platform.docs': '开发文档',
  'menu.open-platform.workbench': '工作台',
  'menu.open-platform.call-logs': 'API 调用日志',
  'menu.open-platform.member-list-test': '成员列表测试',

  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
